// Module-level configuration + persisted-UI-state defaults for the viewer.
// Extracted verbatim from NeuroViewer.jsx.

export const CLINICIAN_SOZ_FEATURES = [
    {
        id: 'bp_gamma',
        category: 'Bandpower',
        emphasis: 'High priority',
        rationale: 'Gamma power is one of the most consistently reported biomarkers of epileptogenic cortex; elevated gamma z-scores can highlight seizure-generating regions.'
    },
    {
        id: 'bp_delta',
        category: 'Bandpower',
        emphasis: 'High priority',
        rationale: 'Elevated delta power captures interictal slowing, a classic marker of dysfunctional cortex near lesions and epileptogenic tissue.'
    },
    {
        id: 'entropy',
        category: 'Complexity',
        emphasis: 'High priority',
        rationale: 'Shannon entropy captures signal complexity; epileptogenic regions can show abnormal entropy during interictal periods and lower entropy during seizures.'
    },
    {
        id: 'c22_19',
        category: 'catch22',
        emphasis: 'High priority',
        rationale: 'DFA fluctuation measures long-range temporal correlations and scale-free dynamics, which are often altered near SOZ and in epileptogenic networks.'
    },
    {
        id: 'fooof_exponent',
        category: 'FOOOF',
        emphasis: 'High priority',
        rationale: 'The aperiodic exponent reflects 1/f spectral slope, excitation/inhibition balance, and neuronal population dynamics; flatter slopes may appear near SOZ.'
    },
    {
        id: 'fooof_offset',
        category: 'FOOOF',
        emphasis: 'High priority',
        rationale: 'The aperiodic offset reflects broadband power level after separating oscillatory peaks from the 1/f background, making it biologically interpretable for atlas abnormalities.'
    }
];


export const DEFAULT_COLOR_MAP = '/brainbrowser/examples/color-maps/spectral.txt';


export const ATLAS_LABEL_COLOR_MAP = '/brainbrowser/examples/color-maps/spectral-brainview.txt';


// ---------------------------------------------------------------------------
// Defaults for the persisted UI state (see utils/uiStatePersistence.js).
// Defined at module scope so both lazy state initialization and the
// "Reset settings" control can reference the same source of truth.
// ---------------------------------------------------------------------------
export const DEFAULT_PANEL_VIEW = 'abnormalities';


export const DEFAULT_SELECTED_FORMAT = 'freesurferasc';


export const DEFAULT_SELECTED_BACKGROUND = '0x000000';


export const DEFAULT_BRAIN_OPACITY = 1.0;


export const DEFAULT_WIREFRAME_ENABLED = false;


export const DEFAULT_SETTINGS_STATE = {
    selectedObjectFile: null,
    selectedIntensityFile: null,
    selectedIntensityFormat: 'text',
    selectedCsvFile: null,
    selectedColorMap: ATLAS_LABEL_COLOR_MAP,
    objectApplied: false,
    csvApplied: false,
    intensityApplied: false,
    objectFileName: "Choose File",
    intensityFileName: "Choose File",
    csvFileName: "Choose File",
    objectFileCache: null,
    intensityFileCache: null,
    csvFileCache: null,
    objectFileObject: null,
    intensityFileObject: null,
    csvFileObject: null,
    objectFormatWarning: null,
    intensityFormatWarning: null,
    selectedHemisphere: 'lh_rh',
    giiEnabled: false
};


// Only these settingsState keys are JSON-serializable and meaningful across
// reloads. File objects / *FileObject / *FileCache references are intentionally
// excluded (non-serializable and meaningless after a refresh).
export const PERSISTED_SETTINGS_KEYS = [
    'selectedColorMap',
    'selectedHemisphere',
    'selectedIntensityFormat',
    'giiEnabled'
];


export const pickPersistedSettings = (settings = {}) => (
    PERSISTED_SETTINGS_KEYS.reduce((acc, key) => {
        if (settings[key] !== undefined) {
            acc[key] = settings[key];
        }
        return acc;
    }, {})
);
